import React, { useState, useEffect } from 'react';
import { Container, Title, Subtitle } from './styles';

import {
    thunksGetNews,
    thunksDeleteNews,
    thunksPutNews,
    thunksPostNews,
} from 'services/News/thunks';

import {
    selectorsGetNews,
    selectorsDeleteNews,
    selectorsPutNews,
    selectorsPostNews,
} from 'services/News/selectors';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';

import { selectEmailsRecords } from 'services/Config/selectors';
import { getEmailsByBranchId } from 'services/Config/thunks';

import NewsForm from './NewsAdmin/NewsFormSubmit';
import NewsTable from './NewsAdmin/NewsTable';

const idToCategory = {
    1: 'SURVOL',
    2: 'HISTORIQUE',
    3: 'CONFIGURATIONS',
    4: 'NOTIFICATIONS',
    5: 'GÉO-BARRIÈRES',
    6: 'RAPPORTS',
    7: 'TABLEAU DE BORD',
    8: 'ADMINISTRATION',
    9: 'ENTRETIEN',
    10: 'DOCUMENTATION',
};

const categoryToId = {
    SURVOL: 1,
    HISTORIQUE: 2,
    CONFIGURATIONS: 3,
    NOTIFICATIONS: 4,
    'GÉO-BARRIÈRES': 5,
    RAPPORTS: 6,
    'TABLEAU DE BORD': 7,
    ADMINISTRATION: 8,
    ENTRETIEN: 9,
    DOCUMENTATION: 10,
};

const idToType = {
    1: 'FONCTIONALITÉ',
    2: 'CORRECTION',
};

const typeToId = {
    FONCTIONALITÉ: 1,
    CORRECTION: 2,
};

const NewsPage = (props) => {
    const [newsItems, setNewsItems] = useState([]);
    const [articles, setArticles] = useState([]);
    const [editingItem, setEditingItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchNews();
        props.getEmailsByBranchId('976');
    }, []);

    const fetchNews = async () => {
        setIsLoading(true);
        try {
            await props.thunksGetNews();
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(
        () => {
            if (props.getNews && Array.isArray(props.getNews)) {
                setArticles(props.getNews);

                const transformedData = props.getNews.flatMap((article) => {
                    return article.news.map((newsItem) => {
                        return {
                            id: newsItem.news_id,
                            articleId: article.article_id,
                            date: new Date(article.publish_date).toLocaleDateString('fr-CA'),
                            category: idToCategory[newsItem.category_id] || 'DIVERS',
                            type: idToType[newsItem.news_type_id] || 'NOUVEAUTÉ',
                            descriptionFR: newsItem.content_fr || '',
                            descriptionEN: newsItem.content_en || '',
                            descriptionES: newsItem.content_es || '',
                        };
                    });
                });

                setNewsItems(transformedData.sort((a, b) => new Date(b.date) - new Date(a.date)));
            }
        },
        [props.getNews]
    );

    /*const handleSubmit = async (formData) => {
        setIsLoading(true);

        try {
            const date = new Date(formData.publish_date);
            date.setUTCHours(12, 0, 0, 0);
            const payload = {
                author: 'System',
                publish_date: date.toISOString(),
                news: formData.news.map((item) => ({
                    ...(item.news_id && { news_id: item.news_id }),
                    category_id: item.category_id,
                    news_type_id: item.news_type_id,
                    news_image: item.news_image || '',
                    content_fr: item.content_fr || null,
                    content_en: item.content_en || null,
                    content_es: item.content_es || null,
                })),
            };

            if (formData.article_id) {
                payload.article_id = formData.article_id;
                await props.thunksPutNews(payload);
            } else {
                await props.thunksPostNews(payload);
            }

            await fetchNews();
            setEditingItem(null);
        } catch (error) {
            console.error('Failed to save news:', error);
            alert(`Failed to save: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };*/

    const handleSubmit = async (formData) => {
        setIsLoading(true);

        try {
            const date = new Date(formData.publish_date);
            date.setUTCHours(12, 0, 0, 0);

            if (formData.article_id) {
                await props.thunksDeleteNews(formData.article_id);
            }

            for (const item of formData.news) {
                const payload = {
                    author: 'System',
                    publish_date: date.toISOString(),
                    news: [
                        {
                            ...(item.news_id && { news_id: item.news_id }),
                            category_id: item.category_id,
                            news_type_id: item.news_type_id,
                            news_image: item.news_image || '',
                            content_fr: item.content_fr || null,
                            content_en: item.content_en || null,
                            content_es: item.content_es || null,
                        },
                    ],
                    ...(formData.article_id && { article_id: formData.article_id }),
                };

                if (formData.article_id) {
                    await props.thunksPutNews(payload);
                } else {
                    await props.thunksPostNews(payload);
                }
            }

            await fetchNews();
            setEditingItem(null);
        } catch (error) {
            console.error('Failed to save news:', error);
            alert(`Failed to save: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (articleId, newsId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer cet élément ?')) {
            setIsLoading(true);
            try {
                const article = articles.find((a) => a.article_id === articleId);

                await props.thunksDeleteNews(articleId);

                await fetchNews();
            } catch (error) {
                console.error('Failed to delete news:', error);
                alert(`Failed to delete: ${error.message}`);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleEdit = async (tableItem) => {
        const article = articles.find((a) => a.article_id === tableItem.articleId);
        const newsItem = article.news.find((n) => n.news_id === tableItem.id);

        const editingData = {
            article_id: article.article_id,
            author: article.author,
            publish_date: article.publish_date,
            news: [
                {
                    news_id: newsItem.news_id,
                    category_id: categoryToId[tableItem.category],
                    news_type_id: typeToId[tableItem.type],
                    content_fr: tableItem.descriptionFR,
                    content_en: tableItem.descriptionEN,
                    content_es: tableItem.descriptionES,
                    news_image: newsItem.news_image || '',
                },
            ],
        };
        setEditingItem(editingData);
        await props.thunksDeleteNews(article.article_id);
        await props.thunksPutNews(editingData);
    };

    const handleCancelEdit = () => {
        setEditingItem(null);
    };

    return (
        <Container>
            <Title>Nouveauté</Title>
            <hr />
            <Subtitle>Faire une annonce</Subtitle>
            <NewsForm
                onSubmit={handleSubmit}
                editingItem={editingItem}
                onCancelEdit={handleCancelEdit}
                isLoading={isLoading}
            />

            <Subtitle>Consulter les annonces</Subtitle>
            <NewsTable
                newsItems={newsItems}
                onEdit={handleEdit}
                onDelete={handleDelete}
                isLoading={isLoading}
            />
        </Container>
    );
};

const mapStateToProps = createStructuredSelector({
    deleteNews: selectorsDeleteNews(),
    postNews: selectorsPostNews(),
    getNews: selectorsGetNews(),
    putNews: selectorsPutNews(),
    emailList: selectEmailsRecords(),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            thunksDeleteNews,
            thunksPostNews,
            thunksGetNews,
            thunksPutNews,
            getEmailsByBranchId,
        },
        dispatch
    );

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(injectIntl(NewsPage))
);
